/**
 * Shared stylesheet for printable clients reports (A4).
 */
export const CLIENTS_REPORT_CSS_STYLE = `
body {
    margin: 0;
    font-family: "Helvetica Neue", Helvetica, Georgia, "Times New Roman", serif;
}

.report.clients {
    color: black;
    background-color: white;
    padding: 20px 10px;
}

.report.clients .title {
    margin-bottom: 10px;
}

.report.clients h2 {
    text-align: center;
    margin: 0px 0px 5px 0px;
    font-size: 18px;
}

.report.clients .brief {
    position: relative;
    margin-top: 40px;
    padding-bottom: 5px;
    border-bottom: 1px solid black;
}

.report.clients .brief .business {
    font-size: 110%;
    font-weight: bold;
}

.report.clients .brief .small {
    font-size: 80%;
    font-weight: normal;
}

.report.clients .brief .price {
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 130%;
}

.report.clients .brief .price .decimal {
    font-size: 90%;
}

.report.clients table {
    width: 100%;
    border: 1px solid #ddd;
    border-collapse: collapse;
}

.report.clients table tr {
    border-bottom: none !important;
}

.report.clients table tr:nth-child(odd) {
    background-color: #ddd;
}

.report.clients table th {
    padding: 3px 5px;
    height: 25px;
}

.report.clients table th:first-child {
    text-align: left;
}

.report.clients table td {
    padding: 3px 5px;
}

.report.clients upp-chart {
    display: block;
    width: 100%;
}

.report.clients upp-chart img,
.report.clients .chart-box img {
    display: block;
    width: 100%;
    height: auto;
    max-width: 100%;
}
`.trim();

/**
 * Returns CSS for printable clients report documents.
 */
export const clientsStyle = (): string => {
    return CLIENTS_REPORT_CSS_STYLE;
};
